// Geometric red-bull brand mark (inline SVG — always crisp, themeable via currentColor accents)
export default function BullMark({ size = 40, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 120 120"
      role="img"
      aria-label="SLN 杀零牛 bull logo"
      className={className}
    >
      <defs>
        <linearGradient id="bmRed" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#FF1E27" />
          <stop offset="1" stopColor="#7F1D1D" />
        </linearGradient>
        <linearGradient id="bmGold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#FACC15" />
          <stop offset="1" stopColor="#B45309" />
        </linearGradient>
      </defs>
      <path d="M14 36 C4 24 9 7 27 5 C20 13 20 22 31 29 L26 38 C20 34 17 34 14 36 Z" fill="url(#bmGold)" />
      <path d="M106 36 C116 24 111 7 93 5 C100 13 100 22 89 29 L94 38 C100 34 103 34 106 36 Z" fill="url(#bmGold)" />
      <path d="M22 42 L40 34 L35 48 Z" fill="#991B1B" />
      <path d="M98 42 L80 34 L85 48 Z" fill="#991B1B" />
      <path d="M38 26 L82 26 L93 54 L75 94 L60 106 L45 94 L27 54 Z" fill="url(#bmRed)" />
      <path d="M60 26 L75 31 L60 60 L45 31 Z" fill="#DC2626" opacity="0.9" />
      <path d="M39 54 L53 49 L50 58 L41 59 Z" fill="#FACC15" />
      <path d="M81 54 L67 49 L70 58 L79 59 Z" fill="#FACC15" />
      <path d="M46 80 L74 80 L68 96 L60 102 L52 96 Z" fill="#450A0A" />
      <circle cx="54" cy="88" r="2.5" fill="#F87171" />
      <circle cx="66" cy="88" r="2.5" fill="#F87171" />
      <circle cx="60" cy="100" r="5.2" fill="none" stroke="url(#bmGold)" strokeWidth="2.6" />
    </svg>
  );
}
